import { useQueryClient } from "@tanstack/react-query";
import { useCurrentStateAndParams } from "@uirouter/react";
import { useDispatch } from "react-redux";

import { useUnmount } from "app/custom-hooks/useUnmount";
import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import { clearAiAgentChatState } from "app/pages/sales-intelligence/modules/ai-agent/store";
import type { SavedSearchRoutingParams } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/types";

export const useLeadGeneratorChatCleanup = (): void => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    const {
        params: { savedSearchId },
    } = useCurrentStateAndParams<Partial<SavedSearchRoutingParams>>();

    useUnmount(() => {
        dispatch(clearAiAgentChatState());

        const threadId = queryClient.getQueryData<string>(aiAgentQueryKeys.leadGenerator.thread(savedSearchId));

        if (!threadId) {
            return;
        }

        void queryClient.removeQueries({
            queryKey: aiAgentQueryKeys.leadGenerator.chat(threadId),
        });

        void queryClient.removeQueries({
            queryKey: aiAgentQueryKeys.leadGenerator.thread(savedSearchId),
        });
    });
};
